import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Logo } from "../components/Logo";

export default function DatenschutzPage() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      <header className="px-4 md:px-8 py-6 border-b border-slate-100">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors" data-testid="datenschutz-back-btn">
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück</span>
          </button>
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
            <Logo size="md" clickable={false} />
          </div>
          <div className="w-20" />
        </div>
      </header>

      <main className="px-4 md:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto prose prose-slate" data-testid="datenschutz-content">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Datenschutzerklärung</h1>
          <p className="text-sm text-slate-400 mb-8">Stand: Februar 2026</p>

          {/* Modul: Verantwortlicher */}
          <section className="mb-8" data-testid="ds-modul-verantwortlicher">
            <h2 className="text-lg font-bold text-slate-900 mb-2">1. Verantwortlicher</h2>
            <p className="text-slate-600 leading-relaxed">
              WebGenerator<br />
              E-Mail: support@webgenerator.io
            </p>
          </section>

          {/* Modul: Übersicht */}
          <section className="mb-8" data-testid="ds-modul-uebersicht">
            <h2 className="text-lg font-bold text-slate-900 mb-2">2. Übersicht der Verarbeitungen</h2>
            <p className="text-slate-600 leading-relaxed">
              Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen Personen.
            </p>
          </section>

          {/* Modul: Server-Logfiles & Hosting */}
          <section className="mb-8" data-testid="ds-modul-hosting">
            <h2 className="text-lg font-bold text-slate-900 mb-2">3. Hosting & Server-Logfiles</h2>
            <p className="text-slate-600 leading-relaxed mb-3">
              Diese Webseite wird bei externen Dienstleistern gehostet (Vercel für das Frontend, Render für das Backend, MongoDB Atlas für die Datenbank). Beim Besuch unserer Webseite werden automatisch Informationen allgemeiner Natur erfasst: Art des Webbrowsers, verwendetes Betriebssystem, Domainname Ihres Internet-Service-Providers, Ihre IP-Adresse und ähnliches.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Diese Daten werden zu folgenden Zwecken verarbeitet: Sicherstellung eines problemlosen Verbindungsaufbaus, reibungslose Nutzung der Webseite, Auswertung der Systemsicherheit und -stabilität. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
            </p>
          </section>

          {/* Modul: Nutzung des Dienstes / KI */}
          <section className="mb-8" data-testid="ds-modul-dienst">
            <h2 className="text-lg font-bold text-slate-900 mb-2">4. Nutzung unseres Dienstes & KI-Verarbeitung</h2>
            <p className="text-slate-600 leading-relaxed mb-3">
              Bei der Nutzung unseres Landingpage-Generators erheben wir die von Ihnen eingegebenen Geschäftsdaten (Firmenname, Branche, Stadt, Kontaktdaten, Adressdaten). Diese Daten werden zur Erstellung Ihrer Landingpage verwendet und in unserer Datenbank gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
            <p className="text-slate-600 leading-relaxed">
              Zur Generierung von Webseitentexten nutzen wir KI-Dienste (OpenAI). Dabei werden Ihre Geschäftsdaten (Firmenname, Branche, Stadt) an den KI-Dienst übermittelt. Es werden keine personenbezogenen Daten wie E-Mail-Adressen oder Telefonnummern an den KI-Dienst weitergegeben. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
          </section>

          {/* Modul: Kontaktformular */}
          <section className="mb-8" data-testid="ds-modul-kontaktformular">
            <h2 className="text-lg font-bold text-slate-900 mb-2">5. Kontaktformular (Lead-System)</h2>
            <p className="text-slate-600 leading-relaxed">
              Wenn Besucher über das auf den generierten Landingpages eingebettete Kontaktformular Anfragen senden, werden die Angaben (Name, Kontaktdaten, Nachricht) zwecks Bearbeitung der Anfrage gespeichert und an den jeweiligen Seitenbetreiber per E-Mail weitergeleitet. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
            </p>
          </section>

          {/* Modul: Registrierung */}
          <section className="mb-8" data-testid="ds-modul-registrierung">
            <h2 className="text-lg font-bold text-slate-900 mb-2">6. Registrierung und Nutzerkonto</h2>
            <p className="text-slate-600 leading-relaxed">
              Sie können ein Nutzerkonto anlegen. Hierbei erheben wir Ihre E-Mail-Adresse und ein von Ihnen gewähltes Passwort. Ihr Passwort wird ausschließlich in verschlüsselter Form (bcrypt-Hash) gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </section>

          {/* Modul: Zahlungen */}
          <section className="mb-8" data-testid="ds-modul-zahlungen">
            <h2 className="text-lg font-bold text-slate-900 mb-2">7. Zahlungsabwicklung (Stripe)</h2>
            <p className="text-slate-600 leading-relaxed">
              Für die Zahlungsabwicklung nutzen wir den Dienst Stripe (Stripe, Inc., 510 Townsend Street, San Francisco, CA 94103, USA). Bei einem Kauf werden Sie zur Bezahlung auf die Seite von Stripe weitergeleitet. Stripe verarbeitet Ihre Zahlungsdaten gemäß deren Datenschutzbestimmungen (<a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 underline">stripe.com/privacy</a>). Wir selbst speichern keine Kreditkarten- oder Kontodaten. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </section>

          {/* Modul: E-Mail-Versand */}
          <section className="mb-8" data-testid="ds-modul-email">
            <h2 className="text-lg font-bold text-slate-900 mb-2">8. E-Mail-Versand (Resend)</h2>
            <p className="text-slate-600 leading-relaxed">
              Für den Versand transaktionaler E-Mails (Bestätigungen, Lead-Benachrichtigungen, Passwort-Links) nutzen wir den Dienst Resend (Resend, Inc.). Dabei wird Ihre E-Mail-Adresse an Resend übermittelt. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
          </section>

          {/* Modul: Domainregistrierung */}
          <section className="mb-8" data-testid="ds-modul-domain">
            <h2 className="text-lg font-bold text-slate-900 mb-2">9. Domainregistrierung</h2>
            <p className="text-slate-600 leading-relaxed mb-3">
              Wenn Sie eine eigene Domain über unseren Dienst registrieren, werden Ihre Kontaktdaten (Name, Adresse, E-Mail, Telefon) an den Domain-Registrar (INWX, InterNetX GmbH, Deutschland) übermittelt. Diese Daten sind für die Domainregistrierung erforderlich. Die Domain wird auf Ihren Namen registriert – Sie sind alleiniger Inhaber.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Für die DNS-Verwaltung nutzen wir Cloudflare (Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
          </section>

          {/* Modul: Cookies */}
          <section className="mb-8" data-testid="ds-modul-cookies">
            <h2 className="text-lg font-bold text-slate-900 mb-2">10. Cookies und lokale Speicherung</h2>
            <p className="text-slate-600 leading-relaxed mb-3">
              Wir setzen ausschließlich technisch notwendige Speichertechniken ein. Analyse-, Tracking- oder Marketing-Dienste verwenden wir nicht; eine Einwilligung ist daher nicht erforderlich.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Login-Token (Browser-Speicher):</strong> Nach der Anmeldung wird ein Zugangstoken (auth_token) in Ihrem Browser gespeichert, damit Sie angemeldet bleiben. Er wird beim Abmelden gelöscht.</li>
              <li><strong>Hinweis-Speicherung:</strong> Ob Sie diesen Hinweis bestätigt haben (wg_notice_ack).</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-3">
              Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG (unbedingt erforderlich für den von Ihnen gewünschten Dienst) sowie Art. 6 Abs. 1 lit. b bzw. lit. f DSGVO.
            </p>
          </section>

          {/* Modul: Kundenbereich */}
          <section className="mb-8" data-testid="ds-modul-dashboard">
            <h2 className="text-lg font-bold text-slate-900 mb-2">Kundenbereich: Bild-Upload, Terminbuchung, Service-Anfragen</h2>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Bild-Upload:</strong> Von Ihnen hochgeladene Bilder speichern wir bei einem Speicherdienst-Anbieter und liefern sie über unseren API-Server auf Ihrer Webseite aus (Art. 6 Abs. 1 lit. b DSGVO). Sie sind für die Nutzungsrechte und Einwilligungen abgebildeter Personen verantwortlich.</li>
              <li><strong>Telefon-Onboarding:</strong> Für die Terminbuchung verarbeiten wir Wunschtermin, Telefonnummer und optionales Thema, um Sie zurückzurufen und schicken Ihnen bzw. uns hierzu E-Mail-Benachrichtigungen (Art. 6 Abs. 1 lit. b DSGVO). Die Daten werden gelöscht, sobald sie nicht mehr erforderlich sind.</li>
              <li><strong>SEO-Service-Anfragen:</strong> Anfragen zu kostenpflichtigen Optimierungen werden gespeichert und per E-Mail an uns weitergeleitet (Art. 6 Abs. 1 lit. b DSGVO).</li>
            </ul>
          </section>

          {/* Modul: SSL */}
          <section className="mb-8" data-testid="ds-modul-ssl">
            <h2 className="text-lg font-bold text-slate-900 mb-2">11. SSL-/TLS-Verschlüsselung</h2>
            <p className="text-slate-600 leading-relaxed">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </section>

          {/* Modul: Rechte */}
          <section className="mb-8" data-testid="ds-modul-rechte">
            <h2 className="text-lg font-bold text-slate-900 mb-2">12. Ihre Rechte</h2>
            <p className="text-slate-600 leading-relaxed">
              Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-slate-600">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4">
              Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: support@webgenerator.io
            </p>
          </section>

          {/* Modul: Beschwerderecht */}
          <section className="mb-8" data-testid="ds-modul-beschwerde">
            <h2 className="text-lg font-bold text-slate-900 mb-2">13. Beschwerderecht</h2>
            <p className="text-slate-600 leading-relaxed">
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
            </p>
          </section>

          {/* Modul: Änderungen */}
          <section data-testid="ds-modul-aenderungen">
            <h2 className="text-lg font-bold text-slate-900 mb-2">14. Änderung dieser Datenschutzerklärung</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
